import { constantMessages } from "./constantString";

export const messages: any = {
  ERR0000: {
    code: "ERR0000",
    message: constantMessages.ERR0000,
  },
  ERR0001: {
    code: "ERR0001",
    message: constantMessages.ERR0001,
  },
  ERR0002: {
    code: "ERR0002",
    message: constantMessages.ERR0002,
  },
  ERR0003: {
    code: "ERR0003",
    message: constantMessages.ERR0003,
  },
  ERR0004: {
    code: "ERR0004",
    message: constantMessages.ERR0004,
  },
  ERR0005: {
    code: "ERR0005",
    message: constantMessages.ERR0005,
  },
  ERR0006: {
    code: "ERR0006",
    message: constantMessages.ERR0006,
  },
  ERR0007: {
    code: "ERR0007",
    message: constantMessages.ERR0007,
  },
  ERR0008: {
    code: "ERR0008",
    message: constantMessages.ERR0008,
  },
  ERR0009: {
    code: "ERR0009",
    message: constantMessages.ERR0009,
  },
  ERR0010: {
    code: "ERR0010",
    message: constantMessages.ERR0010,
  },
  ERR0011: {
    code: "ERR0011",
    message: constantMessages.ERR0011,
  },
  ERR0012: {
    code: "ERR0012",
    message: constantMessages.ERR0012,
  },

  VAL0000: {
    code: "VAL0000",
    message: constantMessages.VAL0000,
  },
  VAL0001: {
    code: "VAL0001",
    message: constantMessages.VAL0001,
  },
  VAL0002: {
    code: "VAL0002",
    message: constantMessages.VAL0002,
  },
  VAL0003: {
    code: "VAL0003",
    message: constantMessages.VAL0003,
  },
  INFO0000: {
    code: "INFO0000",
    message: constantMessages.INFO0000,
  },
  INFO0001: {
    code: "INFO0001",
    message: constantMessages.INFO0001,
  },
  INFO0002: {
    code: "INFO0002",
    message: constantMessages.INFO0002,
  },
  INFO0003: {
    code: "INFO0003",
    message: constantMessages.INFO0003,
  },
  INFO0004: {
    code: "INFO0004",
    message: constantMessages.INFO0004,
  },
  INFO0005: {
    code: "INFO0005",
    message: constantMessages.INFO0005,
  },
  INFO0006: {
    code: "INFO0006",
    message: constantMessages.INFO0006,
  },
  INFO0007: {
    code: "INFO0007",
    message: constantMessages.INFO0007,
  },
  INFO0008: {
    code: "INFO0008",
    message: constantMessages.INFO0008,
  },
  INFO0009: {
    code: "INFO0009",
    message: constantMessages.INFO0009,
  },
  INFO0010: {
    code: "INFO0010",
    message: constantMessages.INFO0010,
  },
  INFO0011: {
    code: "INFO0011",
    message: constantMessages.INFO0011,
  },
  INFO0012: {
    code: "INFO0012",
    message: constantMessages.INFO0012,
  },
  INFO0013: {
    code: "INFO0013",
    message: constantMessages.INFO0013,
  },
  INFO0014: {
    code: "INFO0014",
    message: constantMessages.INFO0014,
  },
  INFO0015: {
    code: "INFO0015",
    message: constantMessages.INFO0015,
  },
  INFO0016: {
    code: "INFO0016",
    message: constantMessages.INFO0016,
  },
  INFO0017: {
    code: "INFO0017",
    message: constantMessages.INFO0017,
  },
  INFO0018: {
    code: "INFO0018",
    message: constantMessages.INFO0018,
  },
  INFO0019: {
    code: "INFO0019",
    message: constantMessages.INFO0019,
  },
  INFO0020: {
    code: "INFO0020",
    message: constantMessages.INFO0020,
  },
  INFO0021: {
    code: "INFO0021",
    message: constantMessages.INFO0021,
  },
  INFO0022: {
    code: "INFO0022",
    message: constantMessages.INFO0022,
  },
  INFO0023: {
    code: "INFO0023",
    message: constantMessages.INFO0023,
  },
  INFO0024: {
    code: "INFO0024",
    message: constantMessages.INFO0024,
  },
  INFO0025: {
    code: "INFO0025",
    message: constantMessages.INFO0025,
  },
  INFO0026: {
    code: "INFO0026",
    message: constantMessages.INFO0026,
  },
  INFO0027: {
    code: "INFO0027",
    message: constantMessages.INFO0027,
  },
  INFO0028: {
    code: "INFO0028",
    message: constantMessages.INFO0028,
  },
  INF00029: {
    code: "INF00029",
    message: constantMessages.INF00029,
  },
  INF00030: {
    code: "INF00030",
    message: constantMessages.INF00030,
  },
  INF00031: {
    code: "INF00031",
    message: constantMessages.INF00031,
  },
  INF00032: {
    code: "INF00032",
    message: constantMessages.INF00032,
  },
  INF00033: {
    code: "INF00033",
    message: constantMessages.INF00033,
  },
  INFO0034: {
    code: "INFO0034",
    message: constantMessages.INFO0034,
  },
  INFO0035: {
    code: "INFO0035",
    message: constantMessages.INFO0035,
  },
  INFO0036: {
    code: "INFO0036",
    message: constantMessages.INFO0036,
  },
  INFO0037: {
    code: "INFO0037",
    message: constantMessages.INFO0037,
  },
  INFO0038: {
    code: "INFO0038",
    message: constantMessages.INFO0038,
  },
  INFO0039: {
    code: "INFO0039",
    message: constantMessages.INFO0039,
  },
  INFO0040: {
    code: "INFO0040",
    message: constantMessages.INFO0040,
  },
  INFO0041: {
    code: "INFO0041",
    message: constantMessages.INFO0041,
  },
  INFO0042: {
    code: "INFO0042",
    message: constantMessages.INFO0042,
  },
  INFO0043: {
    code: "INFO0043",
    message: constantMessages.INFO0043,
  },
  INFO0044: {
    code: "INFO0044",
    message: constantMessages.INFO0044,
  },
  INFO0045: {
    code: "INFO0045",
    message: constantMessages.INFO0045,
  },
};


export const frontendMessages = {
  LEAVE_APPLY:'This user has an appointment today',
}